import React, {Dispatch, SetStateAction, useState} from 'react';
import s from "./ChangePhone.module.css";
import MyBtn from "../ui/MyBtn/MyBtn";
import CustomModal from "../ui/CustomModal/CustomModal";
import MyInput from "../ui/MyInput/MyInput";
import {useFormik, FormikErrors, FormikProvider} from "formik";
import TransparentButton from "../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from "../../assets/img/personalAccount/back.svg";
import info from "../../assets/img/personalAccount/info-circle.svg";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
// import {
//     getNewEmailThunk,
//     sendConfirmationCodeThunk,
//     sendNewEmailThunk,
//     setTokenState
// } from "../../store/reducers/ActionCreators";
// import {setDisabled} from "../../store/reducers/UserSlice";
import * as yup from "yup";
import {changePhoneThunk, sendCodeToNewEmailThunk, setTokenState} from "../../store/reducers/ActionCreators";
import {setDisabled} from "../../store/reducers/UserSlice";
import PopUpTwoFaCodConfirm from "../ui/PopUpTwoFaCodConfirm/PopUpTwoFaCodConfirm";
import modalStyle from '../../styles/styles.module.css'
import PhoneCodesInput from "../ui/PhoneCodesInput/PhoneCodesInput";

type PropsType = {
    setIsChangePhoneProcess: Dispatch<SetStateAction<boolean | null>>
    isChangePhoneProcess: boolean | null
}

interface FormValues {
    phone: string;
}

const validationSchemaPhone = yup.object({
    phone: yup.string()
        .matches(
            /^\+\d[\d\s-]*$/, // Разрешаем + и цифры
            "Phone number must start with '+' and contain only digits"
        )
        .min(6, "Phone number too short (min 6 digits)")
        .max(20, "Phone number too long (max 20 digits)")
        .required("Phone number is required"),
})

const ChangePhone = (props: PropsType) => {

    const [isVerifyModalOpen, setIsVerifyModalOpen] = useState<boolean | null>(false)
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean | null>(false)
    const [isErrorText, setIsErrorText] = useState('Something went wrong. Please try again later.')
    const [newPhone, setNewPhone] = useState('')
    const [isTwoFaModalOpen, setIsTwoFaModalOpen] = useState(false)
    const [isTwoFaCode, setIsTwoFaCode] = useState('')
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState<boolean | null>(false)
    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState<boolean | null>(false)
    const [isTwoFaValid, setIsTwoFaCodeValid] = useState('')

    const dispatch = useAppDispatch()
    const token = useAppSelector(state => state.userReducer.userToken)
    const currentPhone = useAppSelector(state => state.userReducer.user.userData.callPhone)

    const getTwoFaCode = (code: string) => {
        setIsTwoFaCode(code)
        sendDateToChangePhone(code)
    }

    const formikPhone = useFormik<FormValues>({
        initialValues: {
            phone: '',
        },
        enableReinitialize: true,
        validationSchema: validationSchemaPhone,
        validate: (values: FormValues) => {
            const errors: FormikErrors<FormValues> = {};

            // Дополнительная проверка на совпадение с текущим номером
            if (values.phone && values.phone === currentPhone) {
                errors.phone = 'New phone number matches the current one';
            }

            return errors;
        },
        onSubmit: (values: FormValues, formikHelpers) => {
            setNewPhone(values.phone);
            setIsTwoFaModalOpen(true);
        }
    })

    const formikEmailVerify = useFormik({
        initialValues: {
            code: '',
        },
        onSubmit: (values, formikHelpers) => {
            const tempData = {
                ...values,
                phone: newPhone
            }
        }
    })

    const closeAndRedirect = () => {
        setIsSuccessPopupOpen(false)
        setIsTwoFaModalOpen(false)
        props.setIsChangePhoneProcess(false)
        formikPhone.resetForm()
    }

    const clearEmailPin = () => {
        setIsTwoFaCodeValid('')
        setIsErrorPopupOpen(false)
    }

    const sendDateToChangePhone = async (twoFaCode: string) => {
        const prepareDate = {
            phone: newPhone.replace(/[\s-]+/g, ''),
            twoFaCode: twoFaCode,

        }
        dispatch(changePhoneThunk(token, prepareDate)).then(() => {
            setIsSuccessPopupOpen(true)

        }).catch((e) => {
            setIsErrorPopupOpen(true)
            if (e.response.data === "New and old phone are the same" || e.response.data === "Invalid 2fa code") {
                setIsErrorText(e.response.data)
            } else {
                setIsErrorText('Oops, something went wrong. Please try again later.')
            }
        }).finally(() => {
            dispatch(setDisabled(false))
        })
    }


    return (
        <div className={s.change_phone_container}>
            <div className={s.phone_modal_wrapper}>
                <CustomModal isModalOpen={props.isChangePhoneProcess} setIsModalOpen={props.setIsChangePhoneProcess} type={"info"}>
                    <form onSubmit={formikPhone.handleSubmit} className={s.from_wrapper}>
                        <div className={s.iconBlock}>
                            <img src={info} alt=""/>
                        </div>
                        <div className={s.modal_title}>
                            Change your phone number
                        </div>
                        <div className={s.input_block}>
                            <div className={s.input_label}>
                                new Phone Number
                            </div>
                            <FormikProvider value={formikPhone}>
                                <PhoneCodesInput
                                    id="phone"
                                    name="phone"
                                    error={formikPhone.errors.phone}
                                    touched={formikPhone.touched.phone}
                                />
                            </FormikProvider>
                            {/*<MyInput*/}
                            {/*    value={formikPhone.values.phone}*/}
                            {/*    onChange={formikPhone.handleChange}*/}
                            {/*    id={"phone"}*/}
                            {/*    name={"phone"}*/}
                            {/*    isError={!!formikPhone.errors.phone}*/}
                            {/*    touched={formikPhone.touched.phone}*/}
                            {/*/>*/}
                            {/*{formikPhone.errors.phone && <div className={s.error_field}>{formikPhone.errors.phone}</div>}*/}
                        </div>
                        <div className={s.buttonsWrapper}>
                            <TransparentButton
                                buttonType={'confirm'}
                                medium
                                style={{width: 180}}
                                title={'Cancel'}
                                onClick={() => props.setIsChangePhoneProcess(false)}
                                isPersonalAccountBtn
                            />
                            <MyBtn
                                buttonType={'confirm'}
                                medium
                                style={{width: 180}}
                                title={'Next'}
                                type={"submit"}
                                isPersonalAccountBtn
                            />
                        </div>
                    </form>
                </CustomModal>
            </div>
            <CustomModal isModalOpen={isVerifyModalOpen} setIsModalOpen={setIsVerifyModalOpen} type={"confirm"}>
                <form onSubmit={formikEmailVerify.handleSubmit} className={s.from_wrapper}>
                    <div className={s.modal_title}>
                        Email authentication
                    </div>
                    <div className={s.modal_subtitle}>
                        Email with confirmation code was sent to your email address <b>{newPhone}</b>
                    </div>
                    <div className={s.input_block}>
                        <div className={s.input_label}>
                            confirmation Code
                        </div>
                        <MyInput
                            value={formikEmailVerify.values.code}
                            onChange={formikEmailVerify.handleChange}
                            id={"code"}
                            name={"code"}
                        />
                    </div>
                    <div className={s.buttonsWrapper}>
                        <TransparentButton
                            buttonType={'confirm'}
                            medium
                            style={{width: 180}}
                            title={'Cancel'}
                            onClick={() => setIsVerifyModalOpen(false)}
                            icon={<Icon component={() => <Back/>} rev={undefined}/>}
                        />
                        <MyBtn
                            buttonType={'confirm'}
                            medium
                            style={{width: 180}}
                            title={'Confirm'}
                            type={"submit"}
                        />
                    </div>
                </form>
            </CustomModal>

            <div className={s.twoFa_modal_wrapper}>
                {
                    isTwoFaModalOpen ?
                        <PopUpTwoFaCodConfirm sendTransferData={sendDateToChangePhone} onClose={() => setIsTwoFaModalOpen(false)} getPinTwoFa={getTwoFaCode}/>
                        :
                        null
                }
            </div>

            <div className={s.sucess_pop_up_wrapper}>
                <CustomModal isNotify isModalOpen={isSuccessPopupOpen} setIsModalOpen={setIsSuccessPopupOpen}>
                    <div className={modalStyle.modal_content}>
                        <div className={modalStyle.popup_subtitle}>
                            <span className={modalStyle.success}>Success!</span> Your request has been sent successfully.
                        </div>
                        <div className={modalStyle.popup_button_block}>
                            <MyBtn title={'Ok'} isPersonalAccountBtn medium onClick={() => closeAndRedirect()}/>
                        </div>
                    </div>
                </CustomModal>
            </div>

            <div className={s.error_pop_up_wrapper}>
            <CustomModal type="error" isModalOpen={isErrorPopupOpen} setIsModalOpen={setIsErrorPopupOpen}>
                <div className={modalStyle.modal_content}>
                    <div className={modalStyle.popup_subtitle}>
                        {/*Костыль. Нужны правки не бекенде*/}
                        <span className={modalStyle.error}>Failed!</span> {isErrorText}
                        {/*Костыль. Нужны правки не бекенде*/}

                    </div>
                    <div className={modalStyle.popup_button_block}>
                        <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={clearEmailPin}/>
                    </div>
                </div>
            </CustomModal>
            </div>



        </div>
    );
};

export default ChangePhone;
